<div>
  <div>
    <a routerLink="/manage/nav/withdrawals/players/{{ data.playerId }}/details">{{ data.email }}</a>
  </div>
  <div>
    <a routerLink="/manage/nav/withdrawals/players/{{ data.playerId }}/player-commentary">#{{ data.playerId }}</a>
  </div>
  <div>{{ data.playerStatus }}</div>
</div>
